import { Image, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import getImageSrc from "src/utils/getImageSrc";
import { getAppValue } from "src/utils/environment";

export default function AccountRequest({ flow, mode }) {
  const { t } = useTranslation();
  return (
    <>
      <SceneLayout
        absolute={
          <Button
            variant="flatPrimary"
            border-radius="12px"
            py="5px"
            px="14px"
            minWidth="56px"
            position={mode === "fullScreen" ? "fixed" : "absolute"}
            top="14px"
            right="10px"
            onClick={() => flow.push("requester-success")}
          >
            {t("buttons.skip")}
          </Button>
        }
        centerProps={{ width: "320px" }}
        center={
          <>
            <Image
              src={getImageSrc(
                getAppValue({
                  barkio: "better-with-account.svg",
                  default: "account.svg"
                })
              )}
              width="176px"
            />
            <H2 color="highEmphasis" textAlign="center" mt="24px">
              {t("pairing.requester.betterWithAccount")}
            </H2>
            <BodyText mt="8px" color="mediumEmphasis" textAlign="center">
              {t("pairing.requester.text")}
            </BodyText>
          </>
        }
        bottomProps={{ mb: "24px" }}
        bottom={
          <>
            <Button
              variant="containedPrimary"
              onClick={() => flow.push("initial-sign-up")}
              mt="32px"
              minWidth="120px"
            >
              {t("buttons.createFreeAccount")}
            </Button>
          </>
        }
      />
    </>
  );
}
